import { gql } from '@apollo/client';

export const UPDATE_EVENT_CONFIG_MUTATION = gql`
  mutation UpdateEventConfigurations(
    $eventConfigs: [EventConfigInputType!]!
  ) {
    updateEventConfigurations(eventConfigs: $eventConfigs) {
      clientOrganizationKey
      eventId
      hidden
      optOutResell
      parkingFromAlternate
      parkingToAlternate
    }
  }
`;
